export enum DICTIONARY {
  MedicationsAndPrescriptionsLobby,
  Header,
  ContentHeader,
  General,
  MedicationsHistory,
  Status,
  Notifications,
  Applies,
  Equipment,
  UpdatePersonalDetails,
  UpdateBankDetails,
  Requests,
  TestMenu,
  BurgerMenu,
  PersonalDetails,
  PersonalTeam,
  Confirmations,
  CompassRights,
  MedicalReferrals,
  Paychecks,
  DisabledVeteran,
  Treatment,
  PaymentsDeductions,
  Documents,
  OTP_Login,
  UniversalRequest,
  Footer,
  Error,
  ExpenseClaim,
  Home,
  MobileMenu,
  Updates,
  DisabilityApprovals,
  ActivitiesLobby,
  Suppliers,
  B2C,
  Messages,
  LongtermEquipment,
  Reimbursements,
  MedicalCommittees,
  Lawyers,
  SearchResults,
  MedicalCar,
  Feedback,
  EmergencyCallAdmin,
  EmergencyCall,
  DataAnalysis,
  CookieConsent,
  DisabilityCalculator,
  Maintenance,
  RecognitionDashboard,
  SelfServiceReferrals,
  SelfReferral,
  AdminSelfReferralGeneratedList,
  AdminSelfReferralDebug,
  AdminLogs,
}
